export enum AuthSystemError {
  SESSION_ALREADY_EXISTS = "SESSION_ALREADY_EXISTS",
  SESSION_EXPIRED = "SESSION_EXPIRED",
}

export enum FORCE_LOGOUT_REASON {
  INACTIVITY = "INACTIVITY",
  NEW_SESSION = "NEW_SESSION",
}
